import { useCallback, useState } from 'react'

export function useScrollAnchor() {
  const [scrollAnchor, setScrollAnchor] = useState<HTMLElement | null>(null)

  const scrollToAnchor = useCallback(() => {
    if (scrollAnchor) {
      const venuePageMain = document.getElementById('venue-page-main')
      const offsetParent = scrollAnchor.offsetParent as HTMLElement | null

      const scrollBox = venuePageMain ? venuePageMain : window
      const scrollTopBase = venuePageMain
        ? offsetParent?.offsetTop ?? 0
        : window.scrollY + scrollAnchor.getBoundingClientRect().top

      const top = scrollTopBase > 80 ? scrollTopBase - 80 : scrollTopBase

      scrollBox.scrollTo({ top, behavior: 'smooth' })
    }
  }, [scrollAnchor])

  return {
    setScrollAnchor,
    scrollToAnchor,
  }
}
